import { FC, PropsWithChildren } from 'react';

import { Box } from '@eneco/sparky';
import { BoxProps } from '@eneco/sparky/types';

import { swipableBoxStyle } from './SwipableBox.css';

/* This Box can be scrolled horizontally but it does not show the scrollbar */
export const SwipableBox: FC<PropsWithChildren<BoxProps>> = ({ children, ...props }) => {
  return (
    <Box className={swipableBoxStyle} {...props}>
      {children}
    </Box>
  );
};
